import { AnimatePresence, motion } from 'framer-motion';
import { X } from 'lucide-react';
import { useTemplateStudioState } from 'state/hooks/template-studio.hook';

import { Sidebar, SidebarContent, SidebarHeader } from 'components/ui/sidebar';

import { BrandKitForm } from './Form';

export const BRAND_KIT_WIDTH = 318;

export const TemplateStudioBrandKitContainer: React.FC = () => {
  const { isBrandKitOpen, setIsBrandKitOpen } = useTemplateStudioState();

  return (
    <AnimatePresence initial={true}>
      {isBrandKitOpen && (
        <motion.div
          key="brand-kit"
          initial={{ width: 0, maxWidth: 0 }}
          animate={{ width: BRAND_KIT_WIDTH, maxWidth: BRAND_KIT_WIDTH }}
          exit={{ width: 0, maxWidth: 0 }}
          transition={{
            duration: 0.18,
            ease: [0.22, 1, 0.36, 1],
            delay: 0
          }}
          style={{ overflow: 'hidden', minWidth: 0 }}
        >
          <motion.div
            initial={{ x: '100%', opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: '100%', opacity: 0 }}
            transition={{ duration: 0.18, ease: [0.4, 0, 0.2, 1] }}
            style={{ height: '100%', minWidth: BRAND_KIT_WIDTH }}
          >
            <Sidebar
              className="w-[318px] max-w-[318px] h-full box-content"
              side="right"
            >
              <SidebarHeader className="flex flex-row items-center justify-between p-0">
                <p className="text-p-m font-semibold text-base-foreground">
                  Brand Kit
                </p>
                <X
                  size={16}
                  className="cursor-pointer"
                  onClick={() => setIsBrandKitOpen(false)}
                />
              </SidebarHeader>
              <SidebarContent className="">
                <BrandKitForm />
              </SidebarContent>
            </Sidebar>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
